export const ALL_PROCESSES = 'ALL_PROCESSES';